import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import {
  HeaderBannerRail,
  MegaMenuBar,
  MenuLink,
  MobileNav,
  StoreLogo,
} from '@/features/storefront/layouts/chrome/ChromeParts';
import { menuItems, type HeaderProps } from '@/features/storefront/layouts/chrome/types';
import { cn } from '@/lib/cn';

/** Centered masthead over a row of tracked small caps - the boutique look. */
export const Header: FC<HeaderProps> = ({
  storeName,
  logoUrl,
  header,
  menu,
  endSlot,
  preview,
}) => {
  const items = menuItems(menu);
  return (
    <header
      className={cn('border-b', header.sticky && !preview && 'sticky top-0 z-40')}
      style={{
        borderColor: 'var(--storefront-surface)',
        backgroundColor: 'var(--storefront-background)',
      }}
    >
      <HeaderBannerRail header={header} preview={preview} />
      <StorefrontContainer className="relative flex min-h-20 items-center justify-center py-2">
        <MobileNav menu={menu} hiddenFrom="sm:hidden" preview={preview} className="absolute start-0" />
        <StoreLogo
          storeName={storeName}
          logoUrl={logoUrl}
          logoWidthPx={header.logo_width_px}
          showStoreName={header.show_store_name}
          preview={preview}
          nameClassName="text-xl tracking-wide"
          className="gap-3"
        />
        <div className="absolute end-0 flex items-center gap-5">{endSlot}</div>
      </StorefrontContainer>
      {items.length > 0 ? (
        <StorefrontContainer className="hidden justify-center sm:flex">
          <nav
            aria-label={menu?.name}
            className="flex items-center gap-8 border-t pb-3.5 pt-3 text-xs uppercase tracking-[0.18em]"
            style={{ borderColor: 'var(--storefront-surface)' }}
          >
            {items.map((item) => (
              <MenuLink
                key={`${item.label}:${item.url}`}
                item={item}
                preview={preview}
                className="hover:opacity-70"
              />
            ))}
          </nav>
        </StorefrontContainer>
      ) : null}
      <MegaMenuBar header={header} preview={preview} />
    </header>
  );
};
